import React from 'react';
import * as ReactRouterDOM from 'react-router-dom';
import { useAppContext } from '../../context/AppContext.js';
import Grid from '../../components/Grid.js';
import PagingBar from '../../components/PagingBar.js';
import ApiService from '../../services/ApiService.js';
import { getWords } from '../../utils/get-words.js';
import { protect } from '../../utils/protect.js';

const BudgetCapitalTopPart6 = ReactRouterDOM.withRouter(function ({ budgetCapital }) {
  const { i18n, setError } = useAppContext();
  const words = getWords(i18n.code);
  const [count, setCount] = React.useState(null);
  const [pageNumber, setPageNumber] = React.useState(1);
  const pageSize = 10;
  const [items, setItems] = React.useState([]);

  React.useEffect(() => {
    setPageNumber(1);
    loadCount();
  }, [budgetCapital]);

  React.useEffect(() => {
    loadRecords();
  }, [pageNumber, budgetCapital]);

  const loadCount = async function () {
    try {
      const args = {};
      if (budgetCapital.budgetCapitalId !== null && budgetCapital.budgetCapitalId !== undefined) {
        args.budgetCapitalBudgetCapitalId = budgetCapital.budgetCapitalId;
      }
      setCount(await ApiService.getCountBudgetCapitalComments(args));
    }
    catch (error) {
      setError(error);
      return;
    }
  }
  
  const loadRecords = async function () {
    let records = null;
    try {
      const args = {};
      if (budgetCapital.budgetCapitalId !== null && budgetCapital.budgetCapitalId !== undefined) {
        args.budgetCapitalBudgetCapitalId = budgetCapital.budgetCapitalId;
      }
      args.offset = (pageNumber - 1) * pageSize;
      args.limit = pageSize;
      records = await ApiService.getBudgetCapitalComments(args);
    }
    catch (error) {
      setError(error);
      return;
    }
    setItems(records.map((record, index) => ({
      key: record.budgetCapitalCommentId,
      data: [
        record.datetime,
        protect(function ([firstName, lastName]) { return `${firstName} ${lastName}` }, [ record.userFirstName, record.userLastName ]),
        record.comment,
      ],
      record: record
    })));
  }
  
  const refreshMe = async function () {
    await loadCount();
    await loadRecords();
  }
  
  return (
    <div>
      <div>
        <Grid
          contextualActions={[
          ]}
          fields={[
            {
              label: words.datetime,
              type: 'datetime',
              bindIndex: 0,
              secondaryField: {
                type: 'string',
                bindIndex: 1,
              },
            },
            {
              label: words.comment,
              type: 'string',
              bindIndex: 2,
            },
          ]}
          items={items}
        />
        {count !== null && count !== undefined ?
          <PagingBar
            pageNumber={pageNumber}
            setPageNumber={setPageNumber}
            countOfItems={count}
            countOfPages={Math.ceil(count/pageSize)}
          /> :
          null
        }
      </div>
    </div>
  );
})

export default BudgetCapitalTopPart6;
